<template>
    <el-image-viewer
      ref="imgRef"
      :url-list="imageArr"
      :initial-index="0"
      @close="onClose"
    />
</template>
<script lang='ts'>
import { defineComponent, ref, nextTick, reactive, toRefs, inject } from 'vue'
// import { getToken } from '@/utils/cookies'

export default defineComponent({
  name: 'ViewImageList',
  props: {
    images: { type: Array, default: [] as any, required: false },
    visible: { type: Boolean, default: false }
  },
  emits: ['update:visible'],
  setup(props, context) {
    const imgRef = ref(null)
    const $api = inject('$api')
    const baseUrl = $api
    const data = reactive({
      url: '',
      dialogVisible: false,
      imageArr: [] as any,
      onClose() {
        context.emit('update:visible', false)
      }
    })

    nextTick(() => {
      if (props.images) {
        data.imageArr = props.images.map((kk: any) => {
          return baseUrl + kk
        })
      }
    })
    return { imgRef, ...toRefs(data) }
  }

})
</script>
<style  lang="scss" scope>
.img{
  margin: 0 auto;
  display: flex;
  width: 178px;
  height: 178px;
  object-fit: fill;
  border-radius: 2px;
}
.previewBtn{
  color:$light-blue;
}
</style>
